var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"null",style:({height:_vm.iHeidth+'px',background:_vm.bg})},[_c('span',{style:({'width':_vm.imgWidth})},[_c('el-image',{attrs:{"src":require('@/assets/image/common/null.png'),"fit":"fill"}})],1),_c('p',{style:({'paddingTop':_vm.paddingTop+'px'})},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }